import templateCompiler from './template.mobile.art';


const template = templateCompiler();
export default function HelpMobileModule(callback, isOnPremiseDeployMode) {
  if (isOnPremiseDeployMode) {
    let fragments = [];
    return { fragments };
  }

  let ACTIONS = window.UIExtension.UIConsts.FRAGMENT_ACTION;
  let fragments = [
    {
      // 向末尾追加控件
      action: ACTIONS.APPEND,
      // 目标控件名称， 控件将被添加这个空间里面，必须确保它是一个容器类型的控件
      target: 'fv--mobile-toolbar-tabs',
      // 定义控件的以及图标，文字等信息
      template: template,
    },
    {
      action: ACTIONS.APPEND,
      target: 'tabs',
      template: '<dropdown-button tab="help" @on.click="mtabc.switchTab($component)" active>e-sign-china:esignCN.title</dropdown-button>',
    },
  ];
  return { fragments };
}
